import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent, DxTreeViewComponent } from 'devextreme-angular';
import { ParcDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-parc-multi-select',
  templateUrl: './parc-multi-select.component.html',
  styleUrls: ['./parc-multi-select.component.css']
})
export class ParcMultiSelectComponent implements OnInit, OnDestroy {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @ViewChild('parcsTree') parcsTree: DxTreeViewComponent;

  @Select(ControlPanelStore.parcs$) parcs$: Observable<ParcDto[]>;

  @Input() width: number;
  @Input() widthPopUp: number = 250;

  @Input() filterParcId: number;
  @Input() parcIds: number[];
  @Input() titleNull: string;
  @Output() parcIdsChange = new EventEmitter<number[]>();

  @Input() cell: any;

  @Input() disabled: boolean = false;

  InitId = null;

  Parcs: ParcDto[] = [];
  ColumnName = [];

  p: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
  }

  ngOnInit() {
    if(this.parcIds != null) {
      this.InitId = JSON.parse(JSON.stringify(this.parcIds));
    }
    this.p = this.parcs$.subscribe(res => {
      if (res != null) {
        this.Parcs = res.sort((p1, p2) => p1.Identifiant.localeCompare(p2.Identifiant));

        if (this.filterParcId) {
          this.Parcs = this.Parcs.filter(p => p.Id === this.filterParcId);
        } else {
          /*if (this.titleNull && !this.Parcs.find(p => p.Id == 0)) {
            this.Parcs.unshift({ Id: 0, Identifiant: this.titleNull, Designation: this.titleNull });
          }*/
        }

      }
    });
  }

  displayParc = (data : ParcDto) => {
    return data == null ? '' : (data.Identifiant + ' - ' + data.Designation);
  }

  onParcSelectionChanged(e) {
    this.parcIds = [... e.component.getSelectedNodeKeys()];
    if (this.InitId != this.parcIds) {
      this.cell.setValue(this.parcIds);
    }
    this.parcIdsChange.emit(this.parcIds);
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }

  onContentReady(e) {
    this.updateSelection(e.component);
  }

  updateSelection(parc) {
    let parcIds = [...this.parcIds];
    if (!parc) return;

    if(this.parcIds) {
      parc.unselectAll();
      parcIds.forEach((value) => {
        let parcToSelect = this.Parcs.filter(p => p.Id == value);
        parc.selectItem(parcToSelect);
      });
    }
  }

  onOpened() {
    if(this.parcIds == null) {
      this.dataGrid.instance.clearSelection();
    }

    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}
